/************
 * Developed by : Shiva Software Solutions
 * Date : 07-08-2025
 * Descriptions : Route for discharge summary dashboard page
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const dischargeSummaryConfigs = [
  //Redirect to dashboard page
  {
    auth: authRole.user,
    routes: [
      {
        path: '/dischargesummary',
        component: React.lazy(() =>
          import('./DashboardPage/dischargesummaryIndex'),
        ),
      },
    ],
  },
];
